import {List} from 'immutable';
import type {AuthoringSubjectModelV1} from 'resources/augmented/AuthoringSubject/AuthoringSubjectModel.v1';
/**
 * These extensions are intended to ONLY exist on the USER model.
 *
 * The AUTHOR model has definitions for these already. These are for use when things
 * have been included into a query on a USER.
 */

/**
 * Minimal shape of the included `author_v1` relationship used by these extensions.
 * The generated User/Author models are still untyped JS, so we describe only the
 * members accessed here.
 */
interface AuthorWithSubjects {
  isEmpty(): boolean;
  getAuthoringSubjects(): List<AuthoringSubjectModelV1>;
}

/**
 * `this` is bound to the User model at runtime. We describe only the members these
 * extension methods rely on; the underlying generated model is untyped JS.
 */
interface UserWithAuthor {
  getId(): string;
  getAuthor(): AuthorWithSubjects;
  getAuthoringSubjects(): List<AuthoringSubjectModelV1>;
}

export const authoringSubjectExtentions = {
  /*
    Retrieves authoring subject records. All usages of these records should funnel thru this in order to pick up
    our primitive wanrings
    *IMPORTANT* This relies on the inclusion of author_v1.authoring_subjects_v1 on user
  */
  getAuthoringSubjects(this: UserWithAuthor): List<AuthoringSubjectModelV1> {
    if (this.getAuthor().isEmpty()) {
      logger.warn('Attempting to use an extension method without including appropriate resources.');
      logger.warn(`Please include author_v1.authoring_subjects_v1 on user: ${this.getId()}`);
      return List();
    }

    return this.getAuthor().getAuthoringSubjects();
  },

  hasAuthoringSubject(this: UserWithAuthor, subjectId: string): boolean {
    return Boolean(
      this.getAuthoringSubjects().find((subject) => {
        return subject.getId() === subjectId;
      })
    );
  }
};
